import { raundColors } from '@/theme/colors'
import { Checkbox as MantineCheckbox } from '@mantine/core'
import type React from 'react'
import styles from './Checkbox.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type CheckboxProps = {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  label?: string
  value?: string
  style?: React.CSSProperties
  className?: string
  /** ラベル要素に付与する className（フォントサイズ等の上書き用） */
  labelClassName?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
export const Checkbox = ({
  checked,
  defaultChecked,
  onChange,
  disabled,
  label,
  value,
  style,
  className,
  labelClassName,
}: CheckboxProps) => {
  return (
    <MantineCheckbox
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={(e) => onChange?.(e.currentTarget.checked)}
      disabled={disabled}
      label={label}
      value={value}
      style={
        {
          // Mantine v8: --checkbox-size でアイコン含む全体サイズを統一
          // Radio と同様に size変数で指定しないとチェックマーク位置がずれる
          '--checkbox-size': '24px',
          '--checkbox-radius': '4px',
          '--checkbox-color': raundColors.primary.base,
          '--checkbox-icon-color': raundColors.black,
          ...style,
        } as React.CSSProperties
      }
      className={className}
      classNames={{
        input: styles.input,
        label: labelClassName,
      }}
    />
  )
}
